import { render, staticRenderFns } from "./index.vue?vue&type=template&id=142147ce"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ModulesCommonCallToAction: require('/opt/build/repo/components/Modules/Common/CallToAction/index.vue').default,StoryblokComponent: require('/opt/build/repo/components/Storyblok/Component.vue').default,ElementsModal: require('/opt/build/repo/components/Elements/Modal.vue').default})
